import React from 'react';
import TopBar from './TopBar';
import MainHeader from './MainHeader';

const Header: React.FC = () => {
  return (
    <>
      <TopBar />
      <MainHeader />
    </>
  );
};

export default Header;